<template>
    <el-row class="app notFoundBoxAll" type="flex" justify="center">
      <div class="notFoundBox">
        <img class="notFound" src="../../../static/image/notFound.png" alt="">
        <router-link to="/index">
          <img class="error_goHome" src="../../../static/image/error_goHome.png" alt="">
        </router-link>
      </div>

    </el-row>
</template>

<script>
export default {};
</script>

<style scoped>
.notFoundBoxAll{
  align-items: center;
}
.notFoundBox{
  width: 472px;
  flex-wrap:wrap;
  display: flex;
  justify-content: center;
}
.notFound{
  width: 472px;
  height: 340px;
}
.error_goHome{
  margin-top: 54px;
}
</style>



// WEBPACK FOOTER //
// src/components/basics/not-found.vue